import { Quote } from "lucide-react";
import { ArticleFeed } from "./Rubrique";

export default function ChroniquePage() {
  return (
    <div className="space-y-8">
      <div className="bg-[#111827] text-white p-8 md:p-12 relative overflow-hidden" data-testid="chronique-header">
        <Quote size={120} className="absolute -right-4 -top-6 text-red-600/30" />
        <span className="badge-cat">Éditorial</span>
        <h1 className="font-heading text-4xl sm:text-5xl font-black mt-3">Chronique de la semaine</h1>
        <p className="text-zinc-400 mt-3 max-w-2xl">Chaque semaine, la rédaction de Chronique.cd prend de la hauteur sur un fait marquant de l'actualité congolaise. Un regard libre, argumenté et engagé.</p>
      </div>
      <ArticleFeed params={{ category: "chronique" }} title="Toutes les chroniques" testId="chronique-page" />
    </div>
  );
}
